export enum RegistrationRoutes {
  ApplianceDetails = '/appliance-details',
  ApplianceDetailsModelSerial = '/appliance-details-model-serial',
  ExtraApplianceDetails = '/appliance-details/extra',
  MultiPlan = '/appliance-details-multi-plan',
  AdditionalAppliances = '/additional-appliances',
  PersonalDetails = '/personal-details',
  ProtectionDetails = '/protection-details',
  RegistrationConfirmation = '/confirmation',
}
